import React from "react";
import { useContext, useEffect } from "react";
import { AppContext } from "../../../services/Appcontext";
import { useLocation, useParams } from "react-router-dom";
import Charintro from "../../organisms/Charsections/Charintro";
import Charinpic from "../../organisms/Charsections/Charinpic";
import Charmainrole from "../../organisms/Charsections/Charmainrole";
import Charvideos from "../../organisms/Charsections/Charvideos";
import Mapsection from "../../organisms/Homesections/Mapsections/Mapsection";
import Footer from "../../organisms/Footersections/Footer";
import Loader from "../../molecules/Loader";
import { useTranslation } from "react-i18next";

const videos = [
  // { src: "https://www.w3schools.com/html/mov_bbb.mp4", title: "وزارة الثقافة تدرج أسماء شهداء الاطقم الطبية بمشروع عاش هنا تخليدا لدورهم ا الوطني" },
  {
    src: "https://www.youtube.com/embed/sjo6ajQ6uTs",
    title:
      "وزارة الثقافة تدرج أسماء شهداء الاطقم الطبية بمشروع عاش هنا تخليدا لدورهم ا الوطني",
  },
  { src: "https://www.youtube.com/embed/TfiiLdWfCak", title: "Sample Video 2" },
  {
    src: "https://www.youtube.com/embed/Od6LJhVvNOI?list=RDEMzczDcxBoaRuzqJSb2Z75DA",
    title: "Sample Video 3",
  },
];

// const mapLink = "https://www.google.com/maps/embed?pb=..."

export default function Char() {
  const location = useLocation();
  const { getCharById, charById } = useContext(AppContext);
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const { t, i18n } = useTranslation();
  const isArabic = (i18n.language?.split("-")[0] || "ar") === "ar";
  const detail = charById?.data?.characterDetail;
  const noData = t("common.noData");
  const hasArabicValue = (name) => {
    const value = detail?.[name];
    return value != null && String(value).trim() !== "";
  };
  const localized = (name) => {
    const value = isArabic ? detail?.[name] : detail?.[`${name}E`];
    return value != null && String(value).trim() !== "" ? value : noData;
  };
  // console.log(id)
  // const {id}= useParams();

  useEffect(() => {
    getCharById(id);
  }, []);

  if (charById.loading) {
    return <Loader message={t("char.loading")} />;
    // return <Loader message="جاري التحميل..." />;
  }
  let curent_id = charById?.data?.characterDetail["id"];
  let int_id = parseInt(id);

  if (curent_id !== int_id) {
    // return <div>جاري تحميل بيانات الشخصية</div>
    return <Loader message={t("char.loading")} />;
  }
  // console.log('(charById?.data?.characterDetail["id"] !== id)',typeof curent_id , typeof int_id)

  // let long= charById?.data?.characterDetail["longitude"]
  // let lat= charById?.data?.characterDetail["latitude"]
  // console.log("this is the data about the char", charById?.data?.characterVideos)
  // console.log("this is the data about the char", charById?.data.characterDetail.prizes)
  // console.log("this is the data about the char", lat, long)
  // const mapLink = `https://egis.idsc.gov.eg/portal/apps/opsdashboard/index.html#/9c61b5133b694aa0b148b10f0e97e606?p1=${lat},${long}`
  // const mapLink = `https://egis.idsc.gov.eg/portal/apps/opsdashboard/index.html#/9c61b5133b694aa0b148b10f0e97e606?p1=${curent_id}`
  const mapLink = isArabic
    ? `https://egcapitalgis.idsc.gov.eg/portal/apps/dashboards/0944da442d5744fba59defca56128be3#locale=ar&p1=${curent_id}`
    : `https://egcapitalgis.idsc.gov.eg/portal/apps/dashboards/75214dca8c2441db9ec9d8c54e06d60e#p1=${curent_id}`;
  return (
    <div>
      <Charintro data={charById.data?.characterDetail} />

      {charById.data?.characterPhotoGalleries === undefined ||
      charById.data?.characterPhotoGalleries?.length !== 0 ? (
        <Charinpic data={charById.data?.characterPhotoGalleries} />
      ) : null}

      {hasArabicValue("role") ? (
        <Charmainrole
          title={t("char.roles")}
          data={localized("role")}
        />
      ) : null}

      {hasArabicValue("prizes") ? (
        <Charmainrole
          title={t("char.awards")}
          data={localized("prizes")}
        />
      ) : null}

      {charById.data?.characterVideos === undefined ||
      charById.data?.characterVideos?.length !== 0 ? (
        <Charvideos videos={charById.data?.characterVideos} />
      ) : null}
      <Mapsection mapLink={mapLink} height={"md:h-[700px]"} />
      <Footer />
    </div>
  );
}
